import { createContext } from 'react'
type AddToCollectionContextProps = {
    activeChannelId: number
    setActiveChannelId: (index: number) => void
    isReordering?: boolean
}
export const AddToCollectionContext = createContext({} as AddToCollectionContextProps)
